import { validateEnumTranslations } from '../../safety_checks';

export enum ColorKey {
  RED = 'RED',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  PURPLE = 'PURPLE',
  PINK = 'PINK',
}

export const COLOR_OPTIONS_AVAILABLE = [
  { label: ColorKey.RED, value: '#EF4444' },
  { label: ColorKey.BLUE, value: '#3B82F6' },
  { label: ColorKey.GREEN, value: '#10B981' },
  { label: ColorKey.PURPLE, value: '#8B5CF6' },
  { label: ColorKey.PINK, value: '#F472B6' },
];

export const ColorsTranslation = {
  'fr-FR': {
    [ColorKey.RED]: 'Rouge',
    [ColorKey.BLUE]: 'Bleu',
    [ColorKey.GREEN]: 'Vert',
    [ColorKey.PURPLE]: 'Violet',
    [ColorKey.PINK]: 'Rose',
  },
  'en-US': {
    [ColorKey.RED]: 'Red',
    [ColorKey.BLUE]: 'Blue',
    [ColorKey.GREEN]: 'Green',
    [ColorKey.PURPLE]: 'Purple',
    [ColorKey.PINK]: 'Pink',
  },
};

//DONT TOUCH below this line
type ColorLabel = keyof (typeof ColorsTranslation)['fr-FR'];
validateEnumTranslations(ColorKey, ColorsTranslation, '', true);

export const COLOR_OPTIONS = COLOR_OPTIONS_AVAILABLE.filter(
  ({ label }) => ColorsTranslation['fr-FR'][label as ColorLabel] !== undefined,
);
